/* eslint-disable no-fallthrough */
export const JapaneseLatin = {
  ba: 'ба',
  cha: 'ця',
  da: 'да',
  ga: 'га',
  ha: 'ха',
  ja: 'дзя',
  ka: 'ка',
  ma: 'ма',
  na: 'на',
  pa: 'па',
  ra: 'ра',
  sa: 'са',
  sha: 'ся',
  ta: 'та',
  wa: 'ўа',
  ya: 'я',
  za: 'дза',
  be: 'бэ',
  de: 'дэ',
  ge: 'гэ',
  he: 'хэ',
  ke: 'кэ',
  me: 'мэ',
  ne: 'нэ',
  pe: 'пэ',
  re: 'рэ',
  se: 'сэ',
  te: 'тэ',
  ze: 'дзэ',
  bi: 'бі',
  chi: 'ці',
  gi: 'гі',
  hi: 'хі',
  ji: 'дзі',
  ki: 'кі',
  mi: 'мі',
  ni: 'ні',
  pi: 'пі',
  ri: 'ры',
  ro: 'ро',
  shi: 'сі',
  bo: 'бо',
  cho: 'цё',
  do: 'до',
  go: 'го',
  ho: 'хо',
  jo: 'дзё',
  ko: 'ко',
  mo: 'мо',
  no: 'но',
  po: 'по',
  so: 'со',
  sho: 'сё',
  to: 'то',
  wo: 'ўо',
  yo: 'ё',
  zo: 'дзо',
  bu: 'бу',
  fu: 'фу',
  gu: 'гу',
  ju: 'дзю',
  ku: 'ку',
  mu: 'му',
  nu: 'ну',
  pu: 'пу',
  ru: 'ру',
  su: 'су',
  chu: 'цю',
  shu: 'сю',
  tsu: 'цу',
  yu: 'ю',
  zu: 'дзу',
  bya: 'бя',
  gya: 'гя',
  hya: 'хя',
  kya: 'кя',
  mya: 'мя',
  nya: 'ня',
  pya: 'пя',
  rya: 'р’я',
  byo: 'бё',
  gyo: 'гё',
  hyo: 'хё',
  kyo: 'кё',
  myo: 'мё',
  nyo: 'нё',
  pyo: 'пё',
  ryo: 'р’ё',
  byu: 'бю',
  gyu: 'гю',
  hyu: 'хю',
  kyu: 'кю',
  myu: 'мю',
  nyu: 'ню',
  pyu: 'пю',
  ryu: 'р’ю',
  Cha: 'Ця',
  Ba: 'Ба',
  Da: 'Да',
  Ga: 'Га',
  Ha: 'Ха',
  Ja: 'Дзя',
  Ka: 'Ка',
  Ma: 'Ма',
  Na: 'На',
  Pa: 'Па',
  Ra: 'Ра',
  Sa: 'Са',
  Sha: 'Ся',
  Ta: 'Та',
  Wa: 'Ўа',
  Ya: 'Я',
  Za: 'Дза',
  Be: 'Бэ',
  De: 'Дэ',
  Ge: 'Гэ',
  He: 'Хэ',
  Ke: 'Кэ',
  Me: 'Мэ',
  Ne: 'Нэ',
  Pe: 'Пэ',
  Re: 'Рэ',
  Se: 'Сэ',
  Te: 'Тэ',
  Ze: 'Дзэ',
  Bi: 'Бі',
  Chi: 'Ці',
  Gi: 'Гі',
  Hi: 'Хі',
  Ji: 'Дзі',
  Ki: 'Кі',
  Mi: 'Мі',
  Ni: 'Ні',
  Pi: 'Пі',
  Ri: 'Ры',
  Ro: 'Ро',
  Shi: 'Сі',
  Bo: 'Бо',
  Cho: 'Цё',
  Di: 'Ды',
  di: 'ды',
  Do: 'До',
  Go: 'Го',
  Ho: 'Хо',
  Jo: 'Дзё',
  Ko: 'Ко',
  Mo: 'Мо',
  No: 'Но',
  Po: 'По',
  So: 'Со',
  Sho: 'Сё',
  To: 'То',
  Wo: 'Ўо',
  Yo: 'Ё',
  Zo: 'Дзо',
  Bu: 'Бу',
  Chu: 'Цю',
  Fu: 'Фу',
  Gu: 'Гу',
  Ju: 'Дзю',
  Ku: 'Ку',
  Mu: 'Му',
  Nu: 'Ну',
  Pu: 'Пу',
  Ru: 'Ру',
  Su: 'Су',
  Shu: 'Сю',
  Tsu: 'Цу',
  Yu: 'Ю',
  Zu: 'Дзу',
  Bya: 'Бя',
  Gya: 'Гя',
  Hya: 'Хя',
  Kya: 'Кя',
  Mya: 'Мя',
  Nya: 'Ня',
  Pya: 'Пя',
  Rya: 'Р’я',
  Byo: 'Бё',
  Gyo: 'Гё',
  Hyo: 'Хё',
  Kyo: 'Кё',
  Myo: 'Мё',
  Nyo: 'Нё',
  Pyo: 'Пё',
  Ryo: 'Р’ё',
  Byu: 'Бю',
  Gyu: 'Гю',
  Hyu: 'Хю',
  Kyu: 'Кю',
  Myu: 'Мю',
  Nyu: 'Ню',
  Pyu: 'Пю',
  Ryu: 'Р’ю',
  Ue: 'Уэ',
  ue: 'уэ',
  Ua: 'Уа',
  ua: 'уа',
  Ui: 'Уі',
  ui: 'уі',
  ii: 'і',
  II: 'і',
  Uo: 'Уо',
  uo: 'уо',
  '?': '?',
  '.': '.',
  ',': ',',
};

export const Lacinka = {
  soft: {
    Бь: 'B́',
    бь: 'b́',
    Вь: 'V́',
    вь: 'v́',
    Зь: 'Ź',
    зь: 'ź',
    Кь: 'Ḱ',
    кь: 'ḱ',
    Ль: 'Ĺ',
    ль: 'ĺ',
    Мь: 'Ḿ',
    мь: 'ḿ',
    Нь: 'Ń',
    нь: 'ń',
    Пь: 'Ṕ',
    пь: 'ṕ',
    Сь: 'Ś',
    сь: 'ś',
    Ць: 'Ć',
    ць: 'ć',
  },
  alfabet: {
    А: 'A',
    а: 'a',
    Б: 'B',
    б: 'b',
    В: 'V',
    в: 'v',
    Г: 'H',
    г: 'h',
    Д: 'D',
    д: 'd',
    Е: 'Je',
    е: 'je',
    Ё: 'Jo',
    ё: 'jo',
    Ж: 'Ž',
    ж: 'ž',
    З: 'Z',
    з: 'z',
    І: 'I',
    і: 'i',
    Й: 'J',
    й: 'j',
    К: 'K',
    к: 'k',
    Л: 'L',
    л: 'l',
    М: 'M',
    м: 'm',
    Н: 'N',
    н: 'n',
    О: 'O',
    о: 'o',
    П: 'P',
    п: 'p',
    Р: 'R',
    р: 'r',
    С: 'S',
    с: 's',
    Т: 'T',
    т: 't',
    У: 'U',
    у: 'u',
    Ў: 'Ŭ',
    ў: 'ŭ',
    Ф: 'F',
    ф: 'f',
    Х: 'Ch',
    х: 'Ch',
    Ц: 'C',
    ц: 'c',
    Ч: 'Č',
    ч: 'č',
    Ш: 'Š',
    ш: 'š',
    Ы: 'Y',
    ы: 'y',
    Э: 'E',
    э: 'e',
    Ю: 'Ju',
    ю: 'ju',
    Я: 'Ja',
    я: 'ja',
  },
  jokanne: {
    je: 'ie',
    jo: 'io',
    ju: 'ia',
    ja: 'ia',
  },
  consonants: 'BbVvHhDdŽžZzKkLlMmNnPpRrSsTtFfCcČčŠš',
};
